import { ScreenWrapper, ScrollerWrapper } from '../../styles/common';
import {HomeWrapper, Title, SubTitle, ModelImg} from './styles';
import homebg from '../../resources/homebg.png';
import home3dmodel from '../../resources/home3dmodel.png';

const HomeScreen = () => {
    return (
        <ScreenWrapper background={homebg}>
            <ScrollerWrapper>
                <HomeWrapper>
                    <ModelImg src={home3dmodel}/>
                    <Title>Catalog and Standardization Tool</Title>
                    <SubTitle>Browse the catalog for project and module id cards.</SubTitle>
                </HomeWrapper>
            </ScrollerWrapper>
        </ScreenWrapper>
    );
};

export default HomeScreen;
